module.exports = __webpack_public_path__ + "img/1.447a9f47.jpg";